import React from 'react';
import SecondaryNav from '../../components/mweb/SecondaryNav/SecondaryNav';
import Loader from '../../components/mweb/Skeletons/Loader/Loader';
import { connect } from 'react-redux';
import Icon from '../../components/mweb/Icon/Icon';
import Slots from '../../components/mweb/Shipment/Slots';
import {
  getDeliverySlots,
  postDeliverySlots,
  resetShipment,
  setProductsAndDeliverySlots,
} from 'hb-redux-store/feature/checkout/checkout.action';
import Button from '../../components/common/Button/Button';
import ProductCard from '../../components/mweb/ProductCard/ProductCard';
import { getCheckoutRoute } from './checkout.routes';
import RazorpayService from 'hb-redux-store/util/RazorpayService';
import { setAppNotification } from 'hb-redux-store/initial.action';
import {
  CHECKOUT_FAILURE_REDIRECT,
  RUPEE_SYMBOL,
} from 'hb-redux-store/util/constantServices';
import { payAndPlaceOrder } from 'hb-redux-store/feature/wallet/wallet.action';
import history from 'hb-redux-store/history';
import AnalyticsService from 'AnalyticsService';
import {
  convertArrayToObject,
  extractProductItems,
} from 'hb-redux-store/util/miscellaneousServices';

const { clevertap } = AnalyticsService;

class Shipment extends React.Component {
  state = {
    shipments: null,
    statusSet: null,
    activeShipmentIndex: 0,
    shoppingCartId: null,
    cta: 'Continue',
    lastShipment: false,
  };
  VISUAL_STATUS = { ACTIVE: 'active', INACTIVE: 'inactive', DONE: 'done' };
  componentDidMount() {
    this.props.getDeliverySlots();
    RazorpayService.initRazorpay();
  }
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (!this.state.shipments && nextProps.shipments) {
      let {
        shipments,
        shoppingCartId,
        hbWalletAmount = 0,
        totalPayableAmount = 0,
        differenceAmount = 0,
        showPreferredPayment,
        isHBP,
      } = nextProps.shipments;
      const activeShipmentIndex = 0;
      const processedShipments = [];
      const { launchInfo } = nextProps;
      const getVisualStatus = (index, activeIndex) => {
        if (index < activeIndex) return this.VISUAL_STATUS.DONE;
        if (index === activeIndex) return this.VISUAL_STATUS.ACTIVE;
        if (index > activeIndex) return this.VISUAL_STATUS.INACTIVE;
      };
      const statusSet = shipments?.map((shipment, shipmentIndex) => {
        const processedShipment = {
          items: shipment.items,
          shipmentId: shipment.shipmentId,
          deliverySlots: shipment.availableDeliverySlots?.map((s, sIndex) => ({
            timeSlots: s.slots,
            name: s.day,
            date: s?.slotDate,
            deliverySlotId: `${sIndex}-${s.day}`,
          })),
        };
        processedShipments.push(processedShipment);
        return {
          status: getVisualStatus(shipmentIndex, activeShipmentIndex),
          slotExpanded: true,
          shipmentId: shipment.shipmentId,
          selectedDay: null,
          selectedTimeSlot: null,
        };
      });
      if (statusSet) {
        statusSet[activeShipmentIndex].status = this.VISUAL_STATUS.ACTIVE;
        statusSet[activeShipmentIndex].selectedDay =
          processedShipments[activeShipmentIndex]?.deliverySlots?.length &&
          processedShipments[activeShipmentIndex]?.deliverySlots[0];
      }

      const state = {
        shipments: processedShipments,
        statusSet,
        activeShipmentIndex,
        shoppingCartId,
        cta: this.state.cta,
      };
      const productItems = [];
      processedShipments.map(obj => {
        productItems.push(obj?.items);
      });
      if (productItems.length > 0) {
        const key = 'Checkout';
        const payload = {
          ...convertArrayToObject(processedShipments[0].items || []),
          cartItemTotalAmount: totalPayableAmount,
          serviceAbleArea: launchInfo?.adcCode,
          customerType: launchInfo?.customerType,
        };
        clevertap.sendCleverTapEvent(key, payload);
      }
      if (activeShipmentIndex === processedShipments.length - 1) {
        state.lastShipment = true;
        if (showPreferredPayment) {
          if (hbWalletAmount >= totalPayableAmount) {
            state.cta = `Pay ${RUPEE_SYMBOL}${totalPayableAmount} & Place Order`;
          } else {
            state.cta = `Add ${RUPEE_SYMBOL}${differenceAmount} & Place Order`;
          }
        }
      }
      if (!totalPayableAmount && isHBP) {
        state.cta = 'Place Order';
      }
      this.setState(state);
      return false;
    }
    return true;
  }
  componentWillUnmount() {
    this.props.resetShipment();
  }

  failCb = error => {
    console.log('inside failcb error', error);
    if (error?.step) {
      const redirect = error.error?.data?.redirect || error.redirect || null;
      if (redirect?.toLowerCase() === CHECKOUT_FAILURE_REDIRECT.CART) {
        this.props.setAppNotification(
          'Your cart has changed. You will be shortly redirected to cart'
        );
        return setTimeout(() => history.push('/cart'), 2000);
      } else if (
        redirect?.toLowerCase() === CHECKOUT_FAILURE_REDIRECT.SHIPMENT
      ) {
        this.props.setAppNotification(
          'Error with delivery slots. You page will reload shortly to choose new slot.'
        );
        return setTimeout(() => window.location.reload(), 2000);
      } else if (
        redirect?.toLowerCase() === CHECKOUT_FAILURE_REDIRECT.ORDER_FAILURE
      ) {
        this.props.showOrderFailedModal(true);
        history.push('/cart');
      } else if (
        redirect?.toLowerCase() === CHECKOUT_FAILURE_REDIRECT.PG_NOT_LOADED
      ) {
        this.props.setAppNotification(
          'Error loading Payment Gateway. Refresh and try again.'
        );
      } else if (redirect === CHECKOUT_FAILURE_REDIRECT.SHOW_PG_INFO_POPUP) {
        this.showPgInfoPopup(error.pgDetails);
      }
    } else {
      this.props.setAppNotification(
        error?.errorMessage || 'Fail to process payment. Please try again.'
      );
    }
  };

  onCtaAction = (selectedDay, selectedTimeSlot, isHBMoney) => {
    if (!(selectedDay && selectedTimeSlot)) {
      return this.props.setAppNotification('Please select time for delivery.');
    }
    if (this.state.activeShipmentIndex < this.state.shipments.length - 1) {
      const statusSet = this.state.statusSet.map(set => ({ ...set }));
      statusSet[
        this.state.activeShipmentIndex
      ].status = this.VISUAL_STATUS.DONE;
      statusSet[
        this.state.activeShipmentIndex + 1
      ].status = this.VISUAL_STATUS.ACTIVE;
      const state = {
        activeShipmentIndex: this.state.activeShipmentIndex + 1,
        statusSet,
      };
      if (state.activeShipmentIndex === this.state.shipments.length - 1) {
        state.lastShipment = true;
        const {
          hbWalletAmount = 0,
          totalPayableAmount = 0,
          differenceAmount = 0,
          showPreferredPayment,
          isHBP,
        } = this.props.shipments;
        if (showPreferredPayment) {
          if (hbWalletAmount >= totalPayableAmount) {
            state.cta = `Pay ${RUPEE_SYMBOL}${totalPayableAmount} & Place Order`;
          } else {
            state.cta = `Add ${RUPEE_SYMBOL}${differenceAmount} & Place Order`;
          }
        }
        if (!totalPayableAmount && isHBP) {
          state.cta = 'Place Order';
        }
      }
      this.setState(state);
    } else {
      const { totalPayableAmount, isHBP } = this.props.shipments;
      const selectedShipment = this.state.statusSet.map(
        set => set.selectedTimeSlot
      );
      if (isHBMoney || (!totalPayableAmount && isHBP)) {
        const key = 'Add Shipping Info';
        const items = extractProductItems(this.props.shipments?.shipments);
        this.props.setProductsAndDeliverySlots({ items, selectedShipment });

        const payload = {
          ...convertArrayToObject(items || []),
          ...convertArrayToObject(selectedShipment || [], 'Delivery_Slots'),
          cartItemTotalAmount: this.props.shipments.totalPayableAmount,
          serviceAbleArea: this.props.launchInfo?.adcCode,
          source: 'Shipment',
          customerType: this.props.launchInfo?.customerType,
        };
        clevertap.sendCleverTapEvent(key, payload);
        const clevertapPayload = {
          ...convertArrayToObject(items || []),
          ...convertArrayToObject(selectedShipment || [], 'Delivery_Slots'),
          totalAmount: this.props.shipments.totalPayableAmount,
          serviceAbleArea: this.props.launchInfo?.adcCode,
          customerType: this.props.launchInfo?.customerType,
          usedHalalBoxMoney: isHBMoney,
        };
        clevertap.sendCleverTapEvent('Payment Confirmation', clevertapPayload);
        this.props.payAndPlaceOrder({
          failCb: this.failCb,
          shoppingCartId: this.state.shoppingCartId,
          availableDeliverySlots: selectedShipment,
          hbWalletAmount: this.props.shipments.hbWalletAmount,
          totalPayableAmount: this.props.shipments.totalPayableAmount,
          differenceAmount: this.props.shipments.differenceAmount,
        });
      } else {
        const key = 'Add Shipping Info';
        const items = extractProductItems(this.props.shipments?.shipments);
        const payload = {
          ...convertArrayToObject(items || []),
          ...convertArrayToObject(selectedShipment || [], 'Delivery_Slots'),
          cartItemTotalAmount: this.props.shipments.totalPayableAmount,
          serviceAbleArea: this.props.launchInfo?.adcCode,
          source: 'Shipment',
          customerType: this.props.launchInfo?.customerType,
        };
        clevertap.sendCleverTapEvent(key, payload);
        this.props.setProductsAndDeliverySlots({ items, selectedShipment });
        this.props.postDeliverySlots(
          {
            failCb: this.failCb,
            shoppingCartId: this.state.shoppingCartId,
            availableDeliverySlots: selectedShipment,
            isHBMoney,
          },
          getCheckoutRoute('payment')
        );
      }
    }
  };

  setActiveShipment = index => {
    if (index > this.state.activeShipmentIndex) return;
    const activeShipmentIndex = index;
    const statusSet = this.state.statusSet.map((set, setIndex) => {
      const s = { ...set };
      if (setIndex < index) {
        s.status = this.VISUAL_STATUS.DONE;
      } else if (setIndex === index) {
        s.status = this.VISUAL_STATUS.ACTIVE;
      } else {
        s.status = this.VISUAL_STATUS.INACTIVE;
      }
      return s;
    });
    this.setState({ activeShipmentIndex, statusSet });
  };

  onSlotSelection = slot => {
    if (slot.type === 'day') {
      const statusSet = this.state.statusSet.map((set, index) => {
        if (index === this.state.activeShipmentIndex) {
          return {
            ...set,
            selectedDay: slot,
            timeSlots: slot.timeSlots,
            selectedTimeSlot: null,
          };
        }
        return set;
      });
      this.setState({ statusSet });
    } else if (slot.type === 'time') {
      if (!slot.available) return;
      const statusSet = this.state.statusSet.map((set, index) => {
        if (index === this.state.activeShipmentIndex) {
          return {
            ...set,
            slotExpanded: false,
            selectedTimeSlot: {
              ...slot,
              shipmentId: set.shipmentId,
            },
          };
        }
        return set;
      });
      this.setState({ statusSet });
    }
  };

  toggleExpandedSlot = () =>
    this.setState({
      statusSet: this.state.statusSet?.map((s, index) => {
        if (index === this.state.activeShipmentIndex) {
          return { ...s, slotExpanded: !s.slotExpanded };
        }
        return { ...s };
      }),
    });

  render() {
    const { activeShipmentIndex, shipments, statusSet, cta } = this.state;
    const { lastShipment } = this.state;
    let status = null,
      slotExpanded = null,
      selectedDay = null,
      selectedTimeSlot = null,
      daySlots = [],
      timeSlots = [],
      items = null;
    const { preferredPayment, showPreferredPayment, infoText } =
      this.props.shipments || {};
    const { loading } = this.props;
    if (shipments && statusSet) {
      status = statusSet[activeShipmentIndex].status;
      slotExpanded = statusSet[activeShipmentIndex].slotExpanded;
      selectedDay = statusSet[activeShipmentIndex].selectedDay;
      selectedTimeSlot = statusSet[activeShipmentIndex].selectedTimeSlot;
      items = shipments[activeShipmentIndex].items;
      daySlots = shipments[activeShipmentIndex].deliverySlots;
      if (selectedDay) {
        timeSlots = selectedDay.timeSlots;
      }
    }
    return (
      <div className="shipment">
        <SecondaryNav
          showCart={false}
          showSearch={false}
          title="Select Shipment Slots"
          capitalize
        />
        {loading && <Loader />}
        {shipments && (
          <React.Fragment>
            <div className="shipment--title">
              When do you want your items to be delivered?
            </div>
            <div className="shipment--visual">
              {statusSet?.map((s, index) => {
                return (
                  <React.Fragment key={s.shipmentId}>
                    <div
                      className={`shipment--${s.status}`}
                      onClick={() => this.setActiveShipment(index)}
                    >
                      <Icon
                        size={40}
                        class={`icon-shipment${index + 1}-${s.status}`}
                      />
                      <div className="shipment--visual--title">
                        {s.status === this.VISUAL_STATUS.DONE && (
                          <Icon
                            class="icon-shipment-done-tick done-tick"
                            size={15}
                          />
                        )}
                        <span>Shipment {index + 1}</span>
                      </div>
                    </div>
                    {index !== shipments.length - 1 && (
                      <div
                        className={`shipment--visual--connector ${s.status}`}
                      ></div>
                    )}
                  </React.Fragment>
                );
              })}
            </div>
            <div
              className={`shipment--slot-picker ${
                slotExpanded ? 'expanded' : ''
              }`}
            >
              <div className="shipment--slot-picker--title">
                <div
                  className="justify-content--space-between"
                  onClick={this.toggleExpandedSlot}
                >
                  <div>
                    {selectedDay && selectedTimeSlot ? 'Change ' : 'Select '}
                    Delivery Day & Time
                  </div>
                  <Icon
                    class={
                      slotExpanded
                        ? 'icon-common-black-arrow-right arrow-up'
                        : 'icon-common-black-arrow-right arrow-down'
                    }
                    size={12}
                  />
                </div>
                {!slotExpanded && selectedDay && selectedTimeSlot && (
                  <div className="selected-slots">
                    <div
                      className="slots--slot active"
                      onClick={this.toggleExpandedSlot}
                    >
                      {selectedDay.name}
                      {selectedDay.date && (
                        <span className="slots--date">
                          &nbsp;{selectedDay.date}{' '}
                        </span>
                      )}
                    </div>
                    <div
                      className="slots--slot active"
                      onClick={this.toggleExpandedSlot}
                    >
                      {selectedTimeSlot.slot}
                    </div>
                  </div>
                )}
              </div>
              {slotExpanded && daySlots && (
                <div className="shipment--slot-picker--body">
                  <Slots
                    title="Select a Day"
                    slots={daySlots}
                    selectedSlot={selectedDay}
                    onSlotSelection={this.onSlotSelection}
                    type="day"
                  />
                  <Slots
                    title="Select a Time slot"
                    slots={timeSlots}
                    selectedSlot={selectedTimeSlot}
                    onSlotSelection={this.onSlotSelection}
                    type="time"
                  />
                </div>
              )}
            </div>
            {items?.length > 0 &&
              items.map(item => {
                return (
                  <div className="shipment--product-card" key={item.sku}>
                    <ProductCard product={item} shipment />
                  </div>
                );
              })}
            <div className="bottom-sticky-cta">
              <Button
                className="button button-primary full-width large"
                onClick={() => {
                  this.onCtaAction(
                    selectedDay,
                    selectedTimeSlot,
                    showPreferredPayment
                  );
                }}
              >
                {cta}
              </Button>
            </div>
            {showPreferredPayment && lastShipment && (
              <div className="shipment--pay justify-content--space-between">
                <div className="flex-align-items-center">
                  <Icon class="icon-hb-money-wallet" size={30} />
                  <div className="">
                    <div className="flex-align-items-center">
                      <div className="shipment--pay--text">Payment Mode:</div>
                      <div className="shipment--pay--mode">
                        {preferredPayment}
                      </div>
                    </div>
                    {infoText && (
                      <div className="shipment--pay--info-text">{infoText}</div>
                    )}
                  </div>
                </div>
                <Button
                  onClick={() => {
                    this.onCtaAction(selectedDay, selectedTimeSlot);
                  }}
                  className="button action-link more flex-shrink-0"
                >
                  Change
                </Button>
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStatetoProps = ({ checkoutReducer, initialReducer }) => {
  return {
    shipments: checkoutReducer.shipments,
    loading: checkoutReducer.checkoutLoading,
    launchInfo: initialReducer.launchInfo,
  };
};

const mapDispatchToProps = {
  getDeliverySlots,
  postDeliverySlots,
  resetShipment,
  setAppNotification,
  payAndPlaceOrder,
  setProductsAndDeliverySlots,
};

export default connect(mapStatetoProps, mapDispatchToProps)(Shipment);
